'use client';

import { Box, Menu, MenuItem } from '@mui/material';
import { Toolbar, ColumnsPanelTrigger, useGridApiContext } from '@mui/x-data-grid-pro';
import type { GridDensity } from '@mui/x-data-grid-pro';
import { useState } from 'react';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import DensityMediumIcon from '@mui/icons-material/DensityMedium';

/**
 * Data Grid toolbar for ReaxFF: column picker and row density only (export lives in the page header).
 */
export function ReaxffGridToolbar() {
  const apiRef = useGridApiContext();
  const [densityMenuAnchor, setDensityMenuAnchor] = useState<null | HTMLElement>(null);

  const handleDensityClick = (event: React.MouseEvent<HTMLElement>) => {
    setDensityMenuAnchor(event.currentTarget);
  };

  const handleDensityClose = () => {
    setDensityMenuAnchor(null);
  };

  const handleDensitySelect = (density: GridDensity) => {
    apiRef.current.setDensity(density);
    handleDensityClose();
  };

  return (
    <Toolbar>
      <ColumnsPanelTrigger startIcon={<ViewColumnIcon />}>Columns</ColumnsPanelTrigger>

      <Box sx={{ flexGrow: 1 }} />

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <DensityMediumIcon sx={{ color: 'primary.main', fontSize: 18 }} />
        <Box
          component="button"
          type="button"
          onClick={handleDensityClick}
          sx={{
            border: 'none',
            background: 'none',
            color: 'primary.main',
            fontSize: '0.875rem',
            fontFamily: 'inherit',
            cursor: 'pointer',
            padding: '6px 8px',
            display: 'flex',
            alignItems: 'center',
            '&:hover': {
              backgroundColor: 'rgba(25, 118, 210, 0.04)',
              borderRadius: 1,
            },
          }}
        >
          Density
        </Box>
      </Box>

      <Menu anchorEl={densityMenuAnchor} open={Boolean(densityMenuAnchor)} onClose={handleDensityClose}>
        <MenuItem onClick={() => handleDensitySelect('compact')}>Compact</MenuItem>
        <MenuItem onClick={() => handleDensitySelect('standard')}>Standard</MenuItem>
        <MenuItem onClick={() => handleDensitySelect('comfortable')}>Comfortable</MenuItem>
      </Menu>
    </Toolbar>
  );
}
